<script>
import Button from "@/components/atoms/button";
import ButtonGroup from "@/components/molecules/button-group";

export default {
  components: { Button, ButtonGroup },
  props: {
    commune: {
      type: Object,
      required: true
    },
    magasinName: {
      type: String,
      required: true
    },
    isNational: {
      type: Boolean,
      required: true
    },
    context: {
      type: String,
      required: false,
      default: "tunnel"
    }
  },
  emits: ["retry", "cancel"]
};
</script>

<template>
  <div class="u-text-center">
    <p class="u-mb-md u-ml-xlg u-mr-xlg u-pl-xlg u-pr-xlg u-ml-none@sm u-mr-none@sm u-pl-none@sm u-pr-none@sm">
      Le magasin {{ isNational ? '' : magasinName }} ne propose pas la livraison à domicile dans la commune :
    </p>

    <p class="u-font-700">
      {{ commune.code_postal }} - {{ commune.nom_commune }}
    </p>
    <ButtonGroup class="u-mt-xlg u-flex u-flex-column">
      <Button
        radius="full"
        variant="secondary"
        size="md"
        @click="$emit('retry')"
      >
        Tester une autre commune
      </Button>
      <Button
        v-if="context!='clientAccountNavigation'"
        radius="full"
        outline
        variant="primary"
        size="md"
        class="u-mt-md u-mb-md"
        @click="$emit('cancel')"
      >
        Choisir un autre mode de livraison
      </Button>
    </ButtonGroup>
  </div>
</template>
